import React from 'react'
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'
import { cn } from '../../lib/utils'
import './ui.css'

export const Collapsible = CollapsiblePrimitive.Root
export const CollapsibleTrigger = CollapsiblePrimitive.Trigger

export function CollapsibleContent({ children, className, ...rest }) {
  return (
    <CollapsiblePrimitive.Content
      className={cn('ui-collapsible-content', className)}
      {...rest}
    >
      {children}
    </CollapsiblePrimitive.Content>
  )
}
